import { useSyncExternalStore } from "react";

/**
 * Visual-only profanity preference: "hide offensive words", ON by default.
 * Pure localStorage — works for guests and signed-in users alike (account
 * sync of prefs comes with the identity-merge work).
 */
const KEY = "yay:censor";
type Listener = () => void;
const listeners = new Set<Listener>();

function emit() {
  listeners.forEach((l) => l());
}

if (typeof window !== "undefined") {
  window.addEventListener("storage", (e) => {
    if (e.key === KEY) emit();
  });
}

export function getCensorPref(): boolean {
  // Missing key = ON (default). Only an explicit "0" opts out.
  return localStorage.getItem(KEY) !== "0";
}

export function setCensorPref(v: boolean): void {
  localStorage.setItem(KEY, v ? "1" : "0");
  emit();
}

/** Reactive hook — re-renders on toggle (including other tabs). */
export function useCensorPref(): boolean {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    getCensorPref,
  );
}
